export const DEFAULT_LABELS = {
	currentDistributionChannels: 'Select distributors you work with:',
	currentRetailChannels: 'Select retail distribution channels:',
	keheRegion: 'For KeHe, which regions are you available in?',
	mapPolicy: 'Do you have a MAP Policy?',
	UNFIRegion: 'For UNFI, which regions are you available in?',
	otherDistributorRegion: 'For Other Distributors, which regions are you available in?',
	DotFoodsRegion: 'For Dot Foods, which regions are you available in?',
	DPIRegion: 'For DPI, which regions are you available in?',
	PodFoodsRegion: 'For Pod Foods, which regions are you available in?',
	ThresholdEntRegion: 'For Threshold Enterprises, which regions are you available in?'
};
